import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toastSuccess } from "../../components/common/ToastNotification";
import ContactSalesRequest from "../../interfaces/request/ContactSalesRequest";
import ContactSalesUpdateReuest from "../../interfaces/request/ContactSalesUpdateRequest";
import ContactSalesState from "../../interfaces/state/ContactSalesState";
import ContactSales from "../../interfaces/response/ContactSales";
import { getAllContactSalesRequestAsync, contactToSalesAsync, partiallyUpdateContactSalesRequestAsync } from "../../apis/ContactSalesApi";

const initialState: ContactSalesState = {
  loading: false,
  contactSalesRequests: []
}

const updateContactSalesRequestInState = (
  ContactSalesToBeUpdated: number,
  state: ContactSalesState
) => {
  const existingContactRequestIndex = state.contactSalesRequests.findIndex(
    (contactRequest: ContactSales) => contactRequest.id === ContactSalesToBeUpdated
  );
  if (existingContactRequestIndex > -1) {
    state.contactSalesRequests.splice(existingContactRequestIndex, 1);
  }
};

export const getContactSalesRequest = createAsyncThunk(
  "contactRequest/getContactSalesRequest",
  async(status?: number) => {
    return await getAllContactSalesRequestAsync(status);
  }
);

export const contactToSales = createAsyncThunk(
  "contactRequest/contactToSales",
  async (contactInfo: ContactSalesRequest) => {
    await contactToSalesAsync(contactInfo);
  }
);

export const updateContactSalesRequest = createAsyncThunk<
  ContactSales,
  { contactSalesId: number; updateRequest: ContactSalesUpdateReuest }
>(
  "contactRequest/updateContactSalesRequest", async (request) => {
  return await partiallyUpdateContactSalesRequestAsync(request.contactSalesId, request.updateRequest);
});

export const contactSalesSlice = createSlice({
  name: "contactRequest",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getContactSalesRequest.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getContactSalesRequest.fulfilled, (state, action) => {
      state.loading = false;
      state.contactSalesRequests = action.payload;
    });
    builder.addCase(getContactSalesRequest.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(contactToSales.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(contactToSales.fulfilled, (state) => {
      state.loading = false;
      toastSuccess("Your query has been submitted.");
    });
    builder.addCase(contactToSales.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(updateContactSalesRequest.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateContactSalesRequest.fulfilled, (state, action) => {
      updateContactSalesRequestInState(action.payload.id, state);
      toastSuccess("Contact request status updated.");
      state.loading = false;
    });
    builder.addCase(updateContactSalesRequest.rejected, (state) => {
      state.loading = false;
    });
  },
});

export default contactSalesSlice.reducer;
